module.exports = __webpack_public_path__ + "img/task3_icon1.2843ac6f.png";